
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ldhE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a09ceb2f2eff13b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $js7oX = parcelRequire("js7oX");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $b3YrF = parcelRequire("b3YrF");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $bQUgf = parcelRequire("bQUgf");

var $7ptnk = parcelRequire("7ptnk");

var $6N1l2 = parcelRequire("6N1l2");
const $8a09ceb2f2eff13b$var$useSharedState = (0, $574ry.sharedPluginStateHookMigratorFactory)((api)=>{
    const isVisible = (0, $b3YrF.useSharedPluginStateSelector)(api, 'helpDialog.isVisible');
    const imageEnabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'helpDialog.imageEnabled');
    const aiEnabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'helpDialog.aiEnabled');
    return {
        isVisible: isVisible,
        imageEnabled: imageEnabled,
        aiEnabled: aiEnabled
    };
}, (api)=>{
    const { helpDialogState: helpDialogState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'helpDialog'
    ]);
    return {
        isVisible: helpDialogState?.isVisible,
        imageEnabled: helpDialogState?.imageEnabled,
        aiEnabled: helpDialogState?.aiEnabled
    };
});
const $8a09ceb2f2eff13b$var$HelpDialog = ({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, quickInsertEnabled: quickInsertEnabled, intl: intl })=>{
    const { isVisible: isVisible, imageEnabled: imageEnabled, aiEnabled: aiEnabled } = $8a09ceb2f2eff13b$var$useSharedState(pluginInjectionApi);
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        const { state: { tr: tr }, dispatch: dispatch } = editorView;
        (0, $bQUgf.closeHelpCommand)(tr, dispatch);
    }, [
        editorView
    ]);
    const handleEsc = (0, $gwFzn.useCallback)((e)=>{
        if (e.key === 'Escape' && isVisible) closeDialog();
    }, [
        closeDialog,
        isVisible
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleEsc);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleEsc);
        };
    }, [
        handleEsc
    ]);
    const formatting = (0, $7ptnk.getSupportedFormatting)(editorView.state.schema, intl, imageEnabled, quickInsertEnabled, aiEnabled);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6xdDU.default), null, isVisible ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ekolh.default), {
        width: "large",
        onClose: closeDialog,
        testId: "help-modal-dialog"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6N1l2.default), {
        formatting: formatting
    })) : null);
};
var $8a09ceb2f2eff13b$export$2e2bcd8739ae039 = (0, $js7oX.default)($8a09ceb2f2eff13b$var$HelpDialog);

});
parcelRegister("7ptnk", function(module, exports) {

$parcel$export(module.exports, "getSupportedFormatting", () => $cceff92b40424310$export$49b39f11f17c13f0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");

var $d7ZU3 = parcelRequire("d7ZU3");

var $hgeg8 = parcelRequire("hgeg8");

var $hkTaH = parcelRequire("hkTaH");
var $ahUGI = parcelRequire("ahUGI");
var $2UWDO = parcelRequire("2UWDO");
var $iesbi = parcelRequire("iesbi");
var $5Ilz2 = parcelRequire("5Ilz2");
var $4HWgE = parcelRequire("4HWgE");
var $2zaaI = parcelRequire("2zaaI");
var $ocPnd = parcelRequire("ocPnd");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $iu6m9 = parcelRequire("iu6m9");

var $lFjVQ = parcelRequire("lFjVQ");
const $cceff92b40424310$var$codeSm = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius',
    width: "var(--ds-space-300, 24px)",
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});
const $cceff92b40424310$var$codeMd = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    width: '50px',
    textAlign: 'center'
});
const $cceff92b40424310$var$codeLg = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center',
    paddingInline: 'space.150',
    backgroundColor: 'color.background.neutral'
});
const $cceff92b40424310$var$navigationKeymaps = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).navigateToEditorToolbar),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.navToEditorToolbar)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).navigateToFloatingToolbar),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.navToFloatingToolbar)
        }
    ];
const $cceff92b40424310$export$e8eb56737f1ebbe8 = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).bold),
            type: 'strong',
            keymap: ()=>(0, $hgeg8.toggleBold),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "**", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $2zaaI.toolbarMessages).bold), "**"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).italic),
            type: 'em',
            keymap: ()=>(0, $hgeg8.toggleItalic),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "*", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $2zaaI.toolbarMessages).italic), "*"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).underline),
            type: 'underline',
            keymap: ()=>(0, $hgeg8.toggleUnderline)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).strike),
            type: 'strike',
            keymap: ()=>(0, $hgeg8.toggleStrikethrough),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "~~", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $2zaaI.toolbarMessages).strike), "~~"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).subscript),
            type: 'subsup',
            keymap: ()=>(0, $hgeg8.toggleSubscript)
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).superscript),
            type: 'subsup',
            keymap: ()=>(0, $hgeg8.toggleSuperscript)
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading1),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading1),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "#"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading2),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading2),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "##"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading3),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading3),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "###"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading4),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading4),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "####"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading5),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading5),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "#####"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).heading6),
            type: 'heading',
            keymap: ()=>(0, $hgeg8.toggleHeading6),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "######"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).normal),
            type: 'paragraph',
            keymap: ()=>(0, $hgeg8.setNormalText)
        },
        {
            name: formatMessage((0, $5Ilz2.messages).orderedList),
            type: 'orderedList',
            keymap: ()=>(0, $hgeg8.toggleOrderedList),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "1."), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $5Ilz2.messages).unorderedList),
            type: 'bulletList',
            keymap: ()=>(0, $hgeg8.toggleBulletList),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "*"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).blockquote),
            type: 'blockquote',
            keymap: ()=>(0, $hgeg8.toggleBlockQuote),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, '>'), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $2UWDO.messages).codeblock),
            type: 'codeBlock',
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "```"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRule),
            type: 'rule',
            keymap: ()=>(0, $hgeg8.insertRule),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "---"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link),
            type: 'link',
            keymap: ()=>(0, $hgeg8.addLink),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "[", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $4HWgE.toolbarInsertBlockMessages).link), "](http://a.com)"))
        },
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).code),
            type: 'code',
            keymap: ()=>(0, $hgeg8.toggleCode),
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "`", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $2zaaI.toolbarMessages).code), "`"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action),
            type: 'taskItem',
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "[]"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision),
            type: 'decisionItem',
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "<>"), ' ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "Space"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
            type: 'emoji',
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, ":"))
        },
        {
            name: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mention),
            type: 'mention',
            autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeLg
                }, "@"))
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignLeft),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignLeft)
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignCenter),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignCenter)
        },
        {
            name: formatMessage((0, $hkTaH.alignmentMessages).alignRight),
            type: 'alignment',
            keymap: ()=>(0, $hgeg8.alignRight)
        }
    ];
const $cceff92b40424310$var$quickInsertAskAI = ({ formatMessage: formatMessage })=>({
        name: formatMessage((0, $2zaaI.toolbarMessages).askAI),
        type: 'AI',
        keymap: ()=>(0, $hgeg8.askAIQuickInsert)
    });
const $cceff92b40424310$var$otherFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $2zaaI.toolbarMessages).clearFormatting),
            type: 'clearFormatting',
            keymap: ()=>(0, $hgeg8.clearFormatting)
        },
        {
            name: formatMessage((0, $ocPnd.messages).undo),
            type: 'undo',
            keymap: ()=>(0, $hgeg8.undo)
        },
        {
            name: formatMessage((0, $ocPnd.messages).redo),
            type: 'redo',
            keymap: ()=>(0, $dh538.fg)('platform_editor_cmd_y_mac_redo_shortcut') ? (0, $hgeg8.redoAlt) : (0, $hgeg8.redo)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).pastePlainText),
            type: 'paste',
            keymap: ()=>(0, $hgeg8.pastePlainText)
        },
        {
            name: formatMessage((0, $ahUGI.annotationMessages).createComment),
            type: 'annotation',
            keymap: ()=>(0, $hgeg8.addInlineComment)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).CheckUncheckActionItem),
            type: 'checkbox',
            keymap: ()=>(0, $hgeg8.toggleTaskItemCheckbox)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectTableRow),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
                    css: (0, $lFjVQ.shortcutsArray)
                }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2190")), /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2192")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectTableColumn),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
                    css: (0, $lFjVQ.shortcutsArray)
                }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2191")), /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "\u2193")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).InsertTableColumn),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
                    css: (0, $lFjVQ.shortcutsArray)
                }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "=")), /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "-")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).InsertTableRow),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
                    css: (0, $lFjVQ.shortcutsArray)
                }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "]")), /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "[")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).selectColumnResize),
            type: 'table',
            autoFormatting: ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
                    css: (0, $lFjVQ.shortcutsArray)
                }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: (0, $d7ZU3.browser).mac ? $cceff92b40424310$var$codeSm : $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? "\u2318" : 'Ctrl'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, (0, $d7ZU3.browser).mac ? 'Opt' : 'Alt'), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeMd
                }, "Shift"), ' + ', /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                    as: "span",
                    xcss: $cceff92b40424310$var$codeSm
                }, "C")))
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).highlightColor),
            type: 'highlight',
            keymap: ()=>(0, $hgeg8.toggleHighlightPalette)
        }
    ];
const $cceff92b40424310$var$resizeInformationFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).increaseSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.increaseMediaSize)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).decreaseSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.decreaseMediaSize)
        }
    ];
const $cceff92b40424310$var$newResizeInformationFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).increaseElementSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.increaseMediaSize)
        },
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).decreaseElementSize),
            type: 'media',
            keymap: ()=>(0, $hgeg8.decreaseMediaSize)
        }
    ];
const $cceff92b40424310$var$focusTableResizeHandleFormatting = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).focusTableResizeHandle),
            type: 'navigation',
            keymap: ()=>(0, $hgeg8.focusTableResizer)
        }
    ];
const $cceff92b40424310$var$openCellOptionsFormattingtoFormat = ({ formatMessage: formatMessage })=>[
        {
            name: formatMessage((0, $iesbi.helpDialogMessages).openCellOptions),
            type: 'image',
            keymap: ()=>(0, $hgeg8.focusToContextMenuTrigger)
        }
    ];
const $cceff92b40424310$var$imageAutoFormat = {
    name: 'Image',
    type: 'image',
    autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $cceff92b40424310$var$codeLg
        }, "![", /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $iesbi.helpDialogMessages).altText), "](http://www.image.com)"))
};
const $cceff92b40424310$var$quickInsertAutoFormat = ({ formatMessage: formatMessage })=>({
        name: formatMessage((0, $iesbi.helpDialogMessages).quickInsert),
        type: 'quickInsert',
        autoFormatting: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $cceff92b40424310$var$codeLg
            }, "/"))
    });
const $cceff92b40424310$export$49b39f11f17c13f0 = (schema, intl, imageEnabled, quickInsertEnabled, aiEnabled)=>{
    const supportedBySchema = $cceff92b40424310$export$e8eb56737f1ebbe8(intl).filter((format)=>schema.nodes[format.type] || schema.marks[format.type]);
    return [
        ...aiEnabled && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true) ? [
            $cceff92b40424310$var$quickInsertAskAI(intl)
        ] : [],
        ...$cceff92b40424310$var$navigationKeymaps(intl),
        ...$cceff92b40424310$var$otherFormatting(intl),
        ...supportedBySchema,
        ...imageEnabled ? [
            $cceff92b40424310$var$imageAutoFormat
        ] : [],
        ...quickInsertEnabled ? [
            $cceff92b40424310$var$quickInsertAutoFormat(intl)
        ] : [],
        ...$cceff92b40424310$var$focusTableResizeHandleFormatting(intl),
        ...(0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) && (0, $dh538.fg)('platform_editor_breakout_resizing_hello_release') ? $cceff92b40424310$var$newResizeInformationFormatting(intl) : $cceff92b40424310$var$resizeInformationFormatting(intl),
        ...$cceff92b40424310$var$openCellOptionsFormattingtoFormat(intl)
    ];
};

});
parcelRegister("lFjVQ", function(module, exports) {

$parcel$export(module.exports, "header", () => $3c9355e70c559dd2$export$38e42c68cf43b5d4);
$parcel$export(module.exports, "footer", () => $3c9355e70c559dd2$export$adb608be33961c98);
$parcel$export(module.exports, "contentWrapper", () => $3c9355e70c559dd2$export$2a82ddc22e8c7fbb);
$parcel$export(module.exports, "line", () => $3c9355e70c559dd2$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "content", () => $3c9355e70c559dd2$export$a7db06668cad9adb);
$parcel$export(module.exports, "column", () => $3c9355e70c559dd2$export$4e0c71f277ca26b3);
$parcel$export(module.exports, "row", () => $3c9355e70c559dd2$export$120ff0929b202a6d);
$parcel$export(module.exports, "shortcutsArray", () => $3c9355e70c559dd2$export$a09cb1d3ccdca387);
$parcel$export(module.exports, "componentFromKeymapWrapperStyles", () => $3c9355e70c559dd2$export$4e2c9f64cbda9a3c);
$parcel$export(module.exports, "toolbarButton", () => $3c9355e70c559dd2$export$9c7d691958d83aa0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $6fnsQ = parcelRequire("6fnsQ");
const $3c9355e70c559dd2$export$38e42c68cf43b5d4 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex),
    minHeight: "var(--ds-space-300, 24px)",
    padding: `${"var(--ds-space-250, 20px)"} ${"var(--ds-space-500, 40px)"}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: "'none'",
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$6fnsQ.N400})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-neutral-subtle, ${$6fnsQ.N0})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
const $3c9355e70c559dd2$export$adb608be33961c98 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$6fnsQ.N300})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: "var(--ds-space-300, 24px)",
    textAlign: 'right',
    boxShadow: "'none'"
});
const $3c9355e70c559dd2$export$2a82ddc22e8c7fbb = (0, $3jLHL.css)({
    padding: `${"var(--ds-space-250, 20px)"} ${"var(--ds-space-500, 40px)"}`,
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    overflow: 'auto',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${$6fnsQ.N400})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-neutral-subtle, ${$6fnsQ.N0})`
});
const $3c9355e70c559dd2$export$53f1d5ea8de3d7c = (0, $3jLHL.css)({
    background: "var(--ds-background-neutral-subtle, #fff)",
    content: "''",
    display: 'block',
    height: "var(--ds-space-025, 2px)",
    left: 0,
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    minWidth: '604px'
});
const $3c9355e70c559dd2$export$a7db06668cad9adb = (0, $3jLHL.css)({
    minWidth: '524px',
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between'
});
const $3c9355e70c559dd2$export$4e0c71f277ca26b3 = {
    width: '44%',
    '& > ul': {
        padding: 0
    }
};
const $3c9355e70c559dd2$export$120ff0929b202a6d = (0, $3jLHL.css)({
    margin: `${"var(--ds-space-250, 20px)"} 0`,
    display: 'flex',
    justifyContent: 'space-between'
});
const $3c9355e70c559dd2$export$9bb6a6f2774dc082 = {
    '&': {
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(24),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N400)})`,
        letterSpacing: 'normal',
        lineHeight: 1.42857142857143
    }
};
const $3c9355e70c559dd2$export$a09cb1d3ccdca387 = (0, $3jLHL.css)({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: "var(--ds-space-150, 12px)"
});
const $3c9355e70c559dd2$export$4e2c9f64cbda9a3c = (0, $3jLHL.css)({
    flexShrink: 0
});
const $3c9355e70c559dd2$export$9c7d691958d83aa0 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B300)})`}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});

});


parcelRegister("6N1l2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0916096e7125ec3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $804cB = parcelRequire("804cB");

var $hU4DK = parcelRequire("hU4DK");
const $c0916096e7125ec3$var$Modal = ({ formatting: formatting })=>{
    const { onClose: onClose } = (0, $804cB.useModal)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $hU4DK.ModalContent), {
        formatting: formatting,
        onClose: onClose
    });
};
var $c0916096e7125ec3$export$2e2bcd8739ae039 = $c0916096e7125ec3$var$Modal;

});
parcelRegister("hU4DK", function(module, exports) {

$parcel$export(module.exports, "ModalContent", () => $7a777e0b3d085d40$export$6da19a24bf249f17);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");

var $d7ZU3 = parcelRequire("d7ZU3");

var $iesbi = parcelRequire("iesbi");

var $7hXDW = parcelRequire("7hXDW");

var $iXCQx = parcelRequire("iXCQx");

var $83v0T = parcelRequire("83v0T");

var $9cbD1 = parcelRequire("9cbD1");

var $lFjVQ = parcelRequire("lFjVQ");

var $bjhks = parcelRequire("bjhks");
const $7a777e0b3d085d40$export$6da19a24bf249f17 = ({ formatting: formatting, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9cbD1.default), {
        onClose: onClose
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.contentWrapper)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.line)
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.content)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.column)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7hXDW.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $iesbi.helpDialogMessages).keyboardShortcuts)), /*#__PURE__*/ (0, $3jLHL.jsx)("ul", null, formatting.filter((form)=>{
        const keymap = form.keymap && form.keymap();
        return keymap && keymap[(0, $d7ZU3.browser).mac ? 'mac' : 'windows'];
    }).map((form)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const keymap = form.keymap;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $3jLHL.jsx)("li", {
            css: (0, $lFjVQ.row),
            key: `textFormatting-${form.name}`
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iXCQx.default), null, form.name), (0, $bjhks.getComponentFromKeymap)(keymap())));
    }), formatting.filter((form)=>(0, $bjhks.shortcutNamesWithoutKeymap).indexOf(form.type) !== -1).filter((form)=>form.autoFormatting).map((form)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const autoFormatting = form.autoFormatting;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $3jLHL.jsx)("li", {
            css: (0, $lFjVQ.row),
            key: `autoFormatting-${form.name}`
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iXCQx.default), null, form.name), autoFormatting()));
    }))), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.line)
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.column)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7hXDW.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $iesbi.helpDialogMessages).markdown)), /*#__PURE__*/ (0, $3jLHL.jsx)("ul", null, formatting.filter((form)=>(0, $bjhks.shortcutNamesWithoutKeymap).indexOf(form.type) === -1).map((form)=>form.autoFormatting && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $3jLHL.jsx)("li", {
            key: `autoFormatting-${form.name}`,
            css: (0, $lFjVQ.row)
        }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, form.name), form.autoFormatting())))))), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $83v0T.default), null));
};
var $7a777e0b3d085d40$export$2e2bcd8739ae039 = $7a777e0b3d085d40$export$6da19a24bf249f17;

});
parcelRegister("83v0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd52c85f06645d53$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");

var $hgeg8 = parcelRequire("hgeg8");

var $iesbi = parcelRequire("iesbi");

var $lFjVQ = parcelRequire("lFjVQ");

var $bjhks = parcelRequire("bjhks");
const $bd52c85f06645d53$var$ModalFooter = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.footer)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        ...(0, $iesbi.helpDialogMessages).helpDialogTips,
        values: {
            keyMap: (0, $bjhks.getComponentFromKeymap)((0, $hgeg8.openHelp))
        }
    }));
var $bd52c85f06645d53$export$2e2bcd8739ae039 = $bd52c85f06645d53$var$ModalFooter;

});
parcelRegister("bjhks", function(module, exports) {

$parcel$export(module.exports, "shortcutNamesWithoutKeymap", () => $ea2fedb55b62ba84$export$fc7974054e48aed3);
$parcel$export(module.exports, "getComponentFromKeymap", () => $ea2fedb55b62ba84$export$bad16e05505d5562);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $d7ZU3 = parcelRequire("d7ZU3");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $lFjVQ = parcelRequire("lFjVQ");
const $ea2fedb55b62ba84$var$codeLg = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center',
    paddingInline: 'space.150',
    backgroundColor: 'color.background.neutral'
});
const $ea2fedb55b62ba84$var$codeMd = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius',
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    width: '50px',
    textAlign: 'center'
});
const $ea2fedb55b62ba84$var$codeSm = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius',
    width: "var(--ds-space-300, 24px)",
    display: 'inline-block',
    height: "var(--ds-space-300, 24px)",
    lineHeight: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});
const $ea2fedb55b62ba84$var$getKeyParts = (keymap)=>{
    let shortcut = keymap[(0, $d7ZU3.browser).mac ? 'mac' : 'windows'];
    if ((0, $d7ZU3.browser).mac) shortcut = shortcut.replace('Alt', 'Opt');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return shortcut.replace(/\-(?=.)/g, ' + ').split(' ');
};
const $ea2fedb55b62ba84$export$fc7974054e48aed3 = [
    'table',
    'emoji',
    'mention',
    'quickInsert'
];
const $ea2fedb55b62ba84$export$bad16e05505d5562 = (keymap)=>{
    const keyParts = $ea2fedb55b62ba84$var$getKeyParts(keymap);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $lFjVQ.componentFromKeymapWrapperStyles)
    }, keyParts.map((part, index)=>{
        if (part === '+') return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            key: `${keyParts}-${index}`
        }, ' + '));
        else if (part === 'Cmd') return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            key: `${keyParts}-${index}`
        }, "\u2318"));
        else if ([
            'ctrl',
            'alt',
            'opt',
            'shift'
        ].indexOf(part.toLowerCase()) >= 0) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeMd,
            key: `${keyParts}-${index}`
        }, part));
        else if ([
            'f9',
            'f10'
        ].indexOf(part.toLowerCase()) >= 0) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeLg,
            key: `${keyParts}-${index}`
        }, part));
        else if (part.toLowerCase() === 'enter') return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            "data-editor-help-dialog-enter-keymap": "true",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: `${keyParts}-${index}`
        }, "\u23CE");
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            as: "span",
            xcss: $ea2fedb55b62ba84$var$codeSm,
            key: `${keyParts}-${index}`
        }, part.toUpperCase()));
    })));
};

});


parcelRegister("9cbD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0911650ef99a30b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $iesbi = parcelRequire("iesbi");

var $a4eZN = parcelRequire("a4eZN");

var $7hXDW = parcelRequire("7hXDW");

var $1jfCH = parcelRequire("1jfCH");

var $lFjVQ = parcelRequire("lFjVQ");
const $d0911650ef99a30b$var$ModalHeader = (0, $js7oX.default)(({ intl: { formatMessage: formatMessage }, onClose: onClose })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $lFjVQ.header)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7hXDW.default), {
        size: "large"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $iesbi.helpDialogMessages).editorHelp)), /*#__PURE__*/ (0, $3jLHL.jsx)("div", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $a4eZN.default), {
        // @ts-expect-error modal onClose handler requires second parameter of UIAnalyticsEvent, which we don't want to pass
        onClick: onClose,
        title: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))), {
            label: formatMessage((0, $iesbi.helpDialogMessages).closeHelpDialog),
            color: "currentColor",
            spacing: "spacious"
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        css: (0, $lFjVQ.toolbarButton)
    }))));
});
var $d0911650ef99a30b$export$2e2bcd8739ae039 = $d0911650ef99a30b$var$ModalHeader;

});





//# sourceMappingURL=ui.2a29b85d.js.map
